// extracted by mini-css-extract-plugin
module.exports = {"image":"Dropzone_image__hMRJp"};